<template>
  <app-page-wrapper-grid v-if="activeVendor" v-scroll-target class="offerings theme-group-2">
    <scan-and-go-messages v-if="isScanEnabled" />
    <div class="offerings__grid">
      <div class="iw-layout-grid__row p-b-12 offerings__btn">
        <div v-if="showBackButton" class="iw-layout-grid__col--span-12 p-l-16">
          <back-button :route-to="{ name: seatRequired ? ROUTE_NAMES.VENUE_CONTAINER : ROUTE_NAMES.VENDOR_PICKER }" />
        </div>
      </div>
      <vendor-title />
      <ul class="iw-layout-grid__row offerings__card-row p-t-16">
        <li v-for="category in categories" :key="category.id" class="offerings__card-col">
          <category-card :category="category" :show-image="showImages" :show-description="!!category.description" />
        </li>
      </ul>
    </div>
  </app-page-wrapper-grid>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import CategoryCard from "./components/category-card/CategoryCard";
import VendorTitle from "@/components/vendor/vendor-title/VendorTitle";
import BackButton from "@/components/buttons/back-button/BackButton";
import { OAPI_API_TYPE, ROUTE_NAMES } from "@/utils";
import pickupTimeMixin from "@/mixins/pickup-time.mixin";

export const ScanAndGoMessages = defineAsyncComponent(() => import("@/components/messages/ScanAndGoMessages"));

export default {
  name: "Offerings",
  components: { CategoryCard, VendorTitle, ScanAndGoMessages, BackButton },
  mixins: [pickupTimeMixin],
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
      vm.showPickupDisabled();
    });
  },
  data() {
    return {
      prevRoute: null,
      ROUTE_NAMES
    };
  },
  computed: {
    ...mapGetters({
      categories: "vendor/getVendorMenu",
      showImages: "venueSettings/showMenuItemsImages",
      seatRequired: "venueSettings/seatRequired",
      activeVendor: "vendor/getActiveVendor",
      vendorsList: "vendor/getVendorsList"
    }),
    showBackButton() {
      return this.vendorsList.length > 1;
    },
    isScanEnabled() {
      return this.APIType === OAPI_API_TYPE && this.activeVendor?.scanToAddToCart;
    }
  },
  beforeUpdate: function () {
    if (!this.activeVendor) {
      this.$router.push({
        name: ROUTE_NAMES.VENDOR_PICKER
      });
    }
  },
  methods: {
    /**
     * This method shows the user the pickup modal only if Vendor Picker page was bypassed and pickup is disabled
     */
    showPickupDisabled() {
      const isOAPI = this.APIType === OAPI_API_TYPE;
      const isPickupEnabled = this.activeVendor.pickupTimeSelectionEnabled;
      const isAnyPickupSelectable = this.isAnyPickupAvailable(this.activeVendor.id);
      const fromVendorPicker = this.prevRoute?.name === ROUTE_NAMES.VENDOR_PICKER;

      if (isOAPI && !fromVendorPicker && isPickupEnabled && !isAnyPickupSelectable) {
        this.showPickupTimeOptions(this.activeVendor.id);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.offerings {
  // remove max-width for scan items bar
  max-width: initial;

  &__grid {
    max-width: $max-width-desktop;
    margin: auto;
  }
  &__card-col {
    width: auto;
    grid-column-end: span 4;
  }
  &__btn {
    padding-top: 24px;
  }

  ul {
    list-style-type: none;
  }

  @include respond-to-mobile {
    padding-bottom: 0;

    &__card-col {
      grid-column-end: span 2;
    }

    &__card-row {
      grid-gap: 12px;
    }

    &__btn {
      padding-top: 23px;
    }
  }
}
</style>
